// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/pagination/pagination.component.scss
// module id = 434
// module chunks = 0